import { render, staticRenderFns } from "./sales-fulfillment.vue?vue&type=template&id=45756c5d&"
import script from "./sales-fulfillment.vue?vue&type=script&lang=js&"
export * from "./sales-fulfillment.vue?vue&type=script&lang=js&"
import style0 from "./sales-fulfillment.vue?vue&type=style&index=0&id=45756c5d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports